<template>
    <div>
        <div class="wrapper">
            <div class="animated fadeIn">
                <b-row>
                    <b-col>
                        <b-card>
                            <template v-slot:header>
                                Welkom {{userName}}!
                            </template>
                          <DefaultUserLocaleResetButton/>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import ResourceTable from '../../components/ResourceTable';
    import ResourceFilters from '../../components/ResourceFilters';
    import DefaultUserLocaleResetButton from "@/containers/DefaultUserLocaleResetButton.vue";

    export default {
        name: 'dashboard',
        components: {DefaultUserLocaleResetButton, ResourceTable, ResourceFilters},
        data () {
            return {}
        },
        computed: {
            userRole () {
                return this.$store.state.userRole
            },
            userName () {
                return this.$store.state.userName
            }
        },
    }
</script>
